import { defineComponent as _defineComponent } from 'vue'
import { type PropType, computed, toRefs } from "@nuxtjs/composition-api";

import { logoLayoutConfig } from "@/config";
import { type LogoLayouts, logoLayouts } from "@/types";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  animate: {
    type: Boolean,
    default: false,
  },
  layout: {
    type: String as PropType<LogoLayouts>,
    default: logoLayouts.VERTICAL,
  },
},
  setup(__props) {

const props = __props;


const { animate, layout } = toRefs(props);

const LogoConfig = computed(() => {
  return logoLayoutConfig[layout.value];
});

return { __sfc: true,props, animate, layout, LogoConfig }
}

})